<agr-table-v2
  #fertilisersTable
  [dataSource]="dataSource"
  [withStickyHeaders]="true"
  class="fertilisers-overview__table-spaced-cols"
  data-test="overview-v2-component__agr-table-v2"
  [customTableDataSectionHeight]="'calc(95% - 30px + 140px)'"
>
  <ng-container matColumnDef="cropAidName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      {{ 'product' | translate }}
    </th>
    <td mat-cell [attr.aria-label]="'product' | translate" *matCellDef="let row">
      <div style="position: relative">
        <div class="display-inline">
          <div>{{ row.productName }}</div>
          <div class="spacing--margin-top-xs text--label text--gray">{{ row.packageUnit }}</div>
        </div>
        <div class="add-package-container">
          @if (cropAidHasManyArticles(row) && !allArticlesShown(row)) {
            <button class="add-package-btn" data-test="add-package-btn" mat-mini-fab (click)="addNewOrderPlanRow(row)">
              <mat-icon>add</mat-icon>
            </button>
          }
        </div>
      </div>
    </td>
  </ng-container>
  <ng-container matColumnDef="articleName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      {{ 'article' | translate }}
    </th>
    <td mat-cell [attr.aria-label]="'article' | translate" *matCellDef="let row" class="article-center-wrapper">
      @if (isTableOrderable() && !cropAidHasNoArticles(row)) {
        <mat-form-field class="flex__child--auto article-dropdown">
          <mat-label>{{ 'articleName' | translate }}</mat-label>
          <mat-select
            placeholder="'articleName' | translate"
            [ngModel]="row.cropAidWithArticles?.articleNumber"
            (ngModelChange)="onCropAidArticleChange($event, row)"
          >
            @for (cropAidArticle of cropAidArticles | cropAidArticlesFilter: row; track cropAidArticle) {
              <mat-option [value]="cropAidArticle.articleNumber">
                {{ cropAidArticle.articleNames | articleNameTranslation: cropAidArticle }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      @if (isTableOrderable() && cropAidHasNoArticles(row)) {
        <div class="notification notification-error">
          <mat-icon>error</mat-icon>
          {{ 'fertilisers-overview.table.notOrderable' | translate }}
        </div>
      }
    </td>
  </ng-container>
  <ng-container matColumnDef="amount">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      {{ 'fertilisers-overview.table.amount' | translate }}
    </th>
    <td mat-cell [attr.aria-label]="'fertilisers-overview.table.amount' | translate" *matCellDef="let row; let rowIndex = index">
      @if (isTableOrderable()) {
        <mat-form-field style="width: 100px" appearance="fill" class="fertilisers__input mat-form-field__no-spacing">
          <mat-label>{{ row.packageUnit }}</mat-label>
          <input
            matInput
            id="fertilisers-packages-input-with-cursor"
            class="fertilisers__input-text"
            [step]="getPackageSteps(row.increaseOrderUnitQuantity)"
            maxlength="7"
            agrNumber
            [formControl]="$any(amountFormGroup.get(row.amountControlId))"
          />
        </mat-form-field>
      }
    </td>
  </ng-container>
  <ng-container matColumnDef="requisiteAmount">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      {{ 'requisite' | translate }}
    </th>
    <td mat-cell [attr.aria-label]="'requisite' | translate" *matCellDef="let row">
      @if (row.requisiteAmount) {
        <div class="text--bold">{{ row.requisiteAmount | agrNumber: '1.0-2' }} {{ row.cropAidUnit }}</div>
      }
    </td>
  </ng-container>
  <ng-container matColumnDef="stockAmount">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      {{ 'productInventory' | translate }}
    </th>
    <td mat-cell [attr.aria-label]="'productInventory' | translate" *matCellDef="let row">
      <mat-form-field style="width: 90px" appearance="fill" class="fertilisers__input mat-form-field__no-spacing">
        <mat-label>{{ row.cropAidUnit }}</mat-label>
        <input
          matInput
          class="fertilisers__input-text"
          type="number"
          min="0"
          [step]="0.01"
          maxlength="7"
          agrNumber
          (blur)="onFertilizerStockChanged(row.stockAmount, row.cropAidId, row.orderLineId, row)"
          [(ngModel)]="row.stockAmount"
        />
      </mat-form-field>
    </td>
  </ng-container>
  <ng-container matColumnDef="orderedAmount">
    <th class="col-accent" mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'fertilisers-overview.table.ordered' | translate }}</th>
    <td class="col-accent" mat-cell [attr.aria-label]="'requisite' | translate" *matCellDef="let row">
      @if (row.orderedAmount) {
        <div>{{ row.orderedAmount | agrNumber: '1.0-2' }} {{ row.cropAidUnit }}</div>
      }
      @if (!row.orderedAmount) {
        <div>0 {{ row.cropAidUnit }}</div>
      }
    </td>
  </ng-container>
  <ng-container matColumnDef="toOrderAmount">
    <th class="col-accent" mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'fertilisers-overview.table.toOrder' | translate }}</th>
    <td class="col-accent" mat-cell [attr.aria-label]="'requisite' | translate" *matCellDef="let row">
      @if (row.toOrderAmount) {
        <div>{{ row.toOrderAmount | agrNumber: '1.0-2' }} {{ row.cropAidUnit }}</div>
      }
    </td>
  </ng-container>
  <ng-container matColumnDef="result">
    <th class="col-accent" mat-header-cell *matHeaderCellDef mat-sort-header>
      {{ 'result' | translate }}
    </th>
    <td class="col-accent" mat-cell [attr.aria-label]="'result' | translate" *matCellDef="let row">
      <div [ngClass]="row.result >= 0 ? 'text-positive' : 'text-negative'">{{ row.result | number: '1.0-2' }} {{ row.cropAidUnit }}</div>
    </td>
  </ng-container>
  <ng-container *agrTableTopBar>
    <!-- Intentionally empty to remove the top bar -->
  </ng-container>
  <ng-container *agrTableFiltersWrapper>
    <!-- Intentionally empty to remove the clear filters button -->
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
  <tr
    mat-row
    *matRowDef="let element; columns: columnsToDisplay; let i = index"
    class="element-row"
    [class.row-white]="!element.isAccentRowColor"
    [class.row-accent]="element.isAccentRowColor"
  ></tr>
</agr-table-v2>
